import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: 'width:100px' }, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ion_chip, {
          key: 0,
          color: "dark"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_ion_chip, {
          key: 1,
          color: "dark",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event)=>{_ctx.event=$event; _ctx.user_modal=true;}, ["stop","prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_avatar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_img, {
                  src: _ctx.role.user.profile_picture,
                  loading: "lazy"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_label, {
              class: _normalizeClass(_ctx.$style['label'])
            }, {
              default: _withCtx(() => [
                (_ctx.user.uuid === _ctx.role.user.uuid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("orders.fields.validation.you")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.role.user.display_name), 1)),
                (_ctx.display_role)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: _normalizeClass(_ctx.$style['role-container'])
                    }, [
                      _createVNode(_component_ion_text, {
                        class: _normalizeClass(_ctx.$style['role-name']),
                        color: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("(" + _toDisplayString(_ctx.$t('users.roles.' + _ctx.role.role)) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })),
    _createVNode(_component_ion_popover, {
      class: _normalizeClass(_ctx.$style['infos-popover']),
      event: _ctx.event,
      "is-open": _ctx.user_modal,
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.user_modal=false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style['popover-inner'])
            }, [
              _createVNode(_component_ion_avatar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_img, {
                    src: _ctx.role.user.profile_picture,
                    loading: "lazy"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createElementVNode("h3", null, _toDisplayString(_ctx.role.user.display_name), 1),
              ( _ctx.role.user.company_name && _ctx.role.user.company_name !== _ctx.role.user.display_name)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.role.user.company_name), 1))
                : _createCommentVNode("", true),
              ( _ctx.role.user.email)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.role.user.email), 1))
                : _createCommentVNode("", true),
              ( _ctx.role.user.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.role.user.phone), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "event", "is-open"])
  ], 64))
}